import { render } from "./EditUserPageView.vue?vue&type=template&id=e5b4ae7e"
import script from "./EditUserPageView.vue?vue&type=script&lang=js"
export * from "./EditUserPageView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__